<template>
  <div class="content">
    <div class="horizontal-menu-wrapper">
      <slot name="horizontal-menu" />
    </div>
    <div
        id="main-content"
        class="main-content-wrapper">
      <slot name="main-content">
        Main content should be here
      </slot>
      <div class="bottom-white-space"></div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss">
.horizontal-menu-wrapper {
  padding: 0 86px;
}

.bottom-white-space {
  height: 500px;
}
.main-content-wrapper {
  overflow-y: scroll;
  height: 100vh;
  min-width: fit-content;
  padding: 0 20px 0 0;
}
</style>
